<p-dialog
  [(visible)]="showPopup"
  [showHeader]="false"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '1340px', 'max-height': '96vh', 'overflow-y': 'auto' }"
>

  <div class="report-container" *ngIf="!loading; else panelLoading">

    <div class="report-info">

      <div class="report-line">
        <span style="font-weight: bold;font-size: 2rem;padding-left: 6rem;">EPİKRİZ RAPORU</span>
        <epicrisis-input [value]="approvalDate" label="Tarih" [readonly]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.caseDate" label="Vaka Tarihi" [readonly]="true"></epicrisis-input>
        <epicrisis-input [value]="epicrisis.protocolNo" label="Protokol" [readonly]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.doctor" label="Hekim" [readonly]="true"></epicrisis-input>
        <epicrisis-input [value]="epicrisis.patientName" label="Hasta Adı-Soyadı" [readonly]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.age" label="Yaş" [readonly]="true"></epicrisis-input>
        <epicrisis-input [value]="epicrisis.gender" label="Cinsiyet" [readonly]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.diagnoses" label="Ön tanı" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.complaint" label="Şikayet" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.anamnesis" label="Anamnez" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.vitalSigns" label="Vital Bulgular" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.physicalExamination" label="Fiziki Muayene" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.skinExamination" label="Cilt Muayenesi" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.headExamination" label="Baş-boyun Muayenesi" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.respiratoryExamination" label="Solunum Sistemi" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.cardiovascularExamination" label="Kardiyovasküler Sistem" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.abdominalExamination" label="Batın Muayenesi" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.neurologicalExamination" label="Nörolojik Muayenesi" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.gksScore" label="GKS Toplam Skor" [readonly]="displayMode"></epicrisis-input>
        <epicrisis-input [value]="epicrisis.gksText" label="GKS Açıklama" [readonly]="displayMode"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.extremes" label="Ekstremiteler" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.treatment" label="Tedavi" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

      <div class="report-line">
        <epicrisis-input [value]="epicrisis.services" label="Hizmet Şekli" [readonly]="displayMode" [bigInput]="true"></epicrisis-input>
      </div>

    </div>


    <div class="previous-card">

      <button class="btn btn-warning btn-sm" style="margin-left: 6px;margin-right: 6px;" (click)="showPopup = false"><i class="fa fa-angle-left me-2"></i>İptal</button>

      <div class="card-class main-card" [class.approved]="isApproved" [class.selected]="activeCard === 0" (click)="cardClicked(0)" role="button"  tabindex="-1">
        <span style="text-align: center;font-weight: bold;">{{approvalDate}} - Aktif</span>
        <div class="previous-card-line" *ngIf="approvedBy">
          <i class="fa fa-thumbs-up"></i>
          <span>{{approvedBy}}</span>
        </div>
        <button *ngIf="!isApproved && activeCard === 0" class="btn btn-success btn-sm" (click)="approve()">Onay Ver<i class="fa fa-thumbs-up ms-2"></i></button>
        <button *ngIf="isApproved && activeCard === 0" class="btn btn-success btn-sm" (click)="goToPdf()"><i class="fa fa-file me-2"></i>PDF Görüntüle</button>
        <button *ngIf="isApproved && activeCard === 0" class="btn btn-danger btn-sm" (click)="cancelApprove()">Onayı Kaldır<i class="fa fa-thumbs-down ms-2"></i></button>
      </div>
      <div *ngIf="isApproved">
        <button (click)="sendEmail()" class="btn btn-success btn-sm">
          Mail Gönder<i class="fa fa-envelope-o ms-2"></i>
        </button>
      </div>

      <div class="card-class" *ngFor="let record of allRecords; let index = index" [class.selected]="activeCard === index+1" (click)="cardClicked(index+1)" role="button"  tabindex="-1">
        <div class="previous-card-line" *ngIf="record.approvedBy">
          <i style="font-size: .8rem;" class="fa fa-thumbs-up"></i>
          <span style="font-size: .8rem;">{{record.approvedBy.firstName+' '+record.approvedBy.lastName}} - {{record.approvalDate | date: 'dd.MM.yyyy hh:mm'}}</span>
        </div>
        <div class="previous-card-line" *ngIf="record.canceledBy">
          <i style="font-size: .8rem;" class="fa fa-thumbs-down"></i>
          <span style="font-size: .8rem;">{{record.canceledBy.firstName+' '+record.canceledBy.lastName}} - {{record.canceledDate | date: 'dd.MM.yyyy hh:mm'}}</span>
        </div>
      </div>

    </div>

  </div>

  <ng-template #panelLoading>
    <div class="report-container">
      <div class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
    </div>
  </ng-template>



</p-dialog>
<app-send-mail-sms [contacts]="epicrisis.patientInformations" type="email" #epicrisisMail (closed)="onMailClosed()"
  (sendAction)="handleEpicrisisSend($event)">

</app-send-mail-sms>
